'use client';

import React from 'react';

export default function SiteAbout() {
  return (
    <section id="quem-somos" className="py-xl bg-surface-container-lowest overflow-hidden">
      <div className="max-w-7xl mx-auto px-lg">
        <div className="flex flex-col lg:flex-row items-center gap-24">
          <div className="lg:w-1/2 relative">
            <div className="aspect-square rounded-3xl overflow-hidden ambient-shadow ring-8 ring-white">
              <img 
                src="https://lh3.googleusercontent.com/aida-public/AB6AXuB9vTVrcziaeXgAgMFVrIlqT6Q2-GLsrCZkX2rpunZJx0wjkXSPlaIWbA0hO15RgATDmn76UPxtiYTG4ddhfsZwmtu5yK2s9dYTabHjUqNELIXYwE5gKuSFnsTKbS08N3MXqKRPuYMTiEmKfPrmQGd-jsWflugWbnXqU6wyrffxI67c_nQy1u7hGMuPuI6xmvpKbYnzXlh8SG9H84KqM8R-o0HhjpOudQ2eviKRn0A2K_etJcEKginV63hMF4DkpqaujuNONZn8oGI" 
                alt="Processo Artesanal" 
                className="w-full h-full object-cover hover:scale-105 transition-transform duration-700" 
              />
            </div>
            <div className="absolute -bottom-10 -right-10 w-64 h-64 bg-primary/10 rounded-full blur-3xl -z-10"></div>
            
            {/* Stats Overlay */}
            <div className="absolute -bottom-6 -left-6 glass-panel p-lg rounded-2xl ambient-shadow border border-white/50 hidden md:block animate-slide-up">
              <div className="flex items-center gap-md">
                <div className="text-4xl font-playfair font-black text-primary">30+</div>
                <div className="text-[10px] font-black uppercase tracking-widest text-secondary leading-tight">
                  Anos de <br/>Maestria
                </div>
              </div>
            </div>
          </div>

          <div className="lg:w-1/2 space-y-lg">
            <div>
              <span className="text-label-caps text-primary tracking-[0.2em] font-bold">NOSSA FILOSOFIA</span>
              <h2 className="text-h2 text-on-surface mt-2 mb-md">A Arte da Alta Costura em Sergipe</h2>
              <p className="text-body-lg text-secondary leading-relaxed">
                No Eliz Ateliê, acreditamos que por trás de cada vestido há uma história, um olhar cuidadoso e as mãos da <strong>Elizamar</strong> transformando tecido em sonho.
              </p>
            </div>
            
            <p className="text-body-md text-secondary/80 leading-relaxed">
              Combinamos a precisão técnica de décadas de experiência com a sensibilidade e paixão de um coração nordestino. Do primeiro traço ao brilho da festa, cada etapa é conduzida com dedicação absoluta para que você se sinta única.
            </p>


          </div>
        </div>
      </div>
    </section>
  );
}
